const RoundedButton = (props) => {
  const {
    icon,
    text,
    onClick,
    className,
    disabled,
    isWidthFull,
    isLoading,
    disablTextColorChange=true,
    iconPosition="right",
    ...rest
  } = props;

  return (
    <button
      type='submit'
      disabled={disabled ? disabled : false}
      onClick={(e) => {
        // e.preventDefault();
        onClick && onClick(e);
      }}
      className={
        className +
        ` bg-primary ${isWidthFull ? 'w-full justify-center' : 'w-fit'} ${
          disabled ? `bg-opacity-60 cursor-not-allowed ${disablTextColorChange?"text-white":""} ` : ''
        } 
        h-[46px] sm:h-12 md:h-[50px] xl:h-[52px] text-center
        px-8 py-3 text-[14px] md:text-base rounded-full flex items-center gap-2 font-semibold`
      }
      {...rest}
    >
      {isLoading ? (
        <div className='flex items-center gap-2'>
          <span class='loader'></span>
        </div>
      ) : (
          <>
            {icon && iconPosition === "left" && icon}
            {text}
            {icon && iconPosition === "right" && icon}
        </>
      )}
    </button>
  );
};

export default RoundedButton;
